import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EventEmitterService } from 'src/app/services/shared.service';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
})
export class MainComponent implements OnInit {
    idEmpresa: number;
    nombreUsuario = '';
    nombreEmpresa = '';

    empresaSeleccionada = false;
    esAdmin = false;

    constructor(private _eventEmitter: EventEmitterService, public router: Router) {}

    ngOnInit(): void {
        this.esAdmin = localStorage.getItem('rol') === 'admin_empresa';
        this.nombreUsuario = localStorage.getItem('nombreUsuario') || '';
        this.nombreEmpresa = localStorage.getItem('nombreEmpresa') || '';
        this.idEmpresa = parseInt(localStorage.getItem('idEmpresa'));
        this.empresaSeleccionada = !!this.idEmpresa;

        this._eventEmitter.actualizarToolBar.subscribe(() => {
            this.esAdmin = localStorage.getItem('rol') === 'admin_empresa';
            this.nombreUsuario = localStorage.getItem('nombreUsuario') || '';
            this.nombreEmpresa = localStorage.getItem('nombreEmpresa') || '';
            this.idEmpresa = parseInt(localStorage.getItem('idEmpresa'));
            this.empresaSeleccionada = !!this.idEmpresa;
        });
    }
}
